import type { DateElements } from '@/modules/common/types/ui.ts';

export const ALL_DATE_ELEMENTS: DateElements = {
  input: true,
  today: true,
  copy: true,
  calendar: true,
} as const;

export const DATE_PICKER_CONFIG_RU = {
  direction: 'ltr',
  format: 'dd.mm.yyyy',
  separator: ' - ',
  applyLabel: 'Сохранить',
  Today: 'Сохранить',
  cancelLabel: 'Отмена',
  weekLabel: 'Н',
  daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  monthNames: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  firstDay: 1,
} as const;

export const DATE_PICKER_CONFIG_EN = {
  direction: 'ltr',
  format: 'dd.mm.yyyy',
  separator: ' - ',
  applyLabel: 'Save',
  Today: 'Save',
  cancelLabel: 'Cancel',
  weekLabel: 'W',
  daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  firstDay: 1,
} as const;
